import type { Item } from "@/lib/cases";
import { fmt } from "@/lib/money";
import { itemAlt } from "@/lib/seo";

// CS2 rarity names by the colour the data ships with (stickers reuse the colours under their own names).
const SKIN_RARITY: Record<string, string> = {
  "#b0c3d9": "Consumer", "#5e98d9": "Industrial", "#4b69ff": "Mil-Spec", "#8847ff": "Restricted",
  "#d32ce6": "Classified", "#eb4b4b": "Covert", "#e4ae39": "★ Rare Special",
};
const STICKER_RARITY: Record<string, string> = { "#4b69ff": "High Grade", "#8847ff": "Remarkable", "#d32ce6": "Exotic", "#eb4b4b": "Extraordinary" };
export const rarityName = (it: Item) => (it.n.startsWith("Sticker |") ? STICKER_RARITY : SKIN_RARITY)[it.r.toLowerCase()] ?? "";

/** Skin tile: art on a rarity-tinted floor, weapon + skin name, wear, value. Optional odds (+ rarity label) and footer actions. */
export default function ItemCard({ item, value = item.p, odds, range, foot, muted }: {
  item: Item; value?: number; odds?: number; range?: string; foot?: React.ReactNode; muted?: boolean;
}) {
  const [weapon, skin] = item.n.replace("StatTrak™ ", "").split(" | ");
  const rarity = odds !== undefined ? rarityName(item) : "";
  return (
    <div
      className={`rarity-tile item-card flex flex-col rounded-lg p-2.5 ${muted ? "opacity-50" : ""}`}
      style={{ "--rc": item.r } as React.CSSProperties}
      title={range}
    >
      <div className="flex h-5 items-center justify-between gap-2 text-[11px] font-bold">
        <span className="flex gap-1">
          {item.w && <span className="rounded bg-bg/70 px-1.5 py-0.5 text-muted">{item.w}</span>}
          {item.st && <span className="rounded bg-accent/20 px-1.5 py-0.5 text-accent" title="StatTrak™">ST</span>}
        </span>
        {odds !== undefined && <span className="tnum text-muted">{odds < 0.01 ? "<0.01" : odds.toFixed(odds < 1 ? 3 : 2)}%</span>}
      </div>
      <img src={item.i} alt={itemAlt(item)} loading="lazy" className="mx-auto my-1.5 aspect-[4/3] w-full max-w-[150px] object-contain" />
      <div className="truncate text-[11px] font-semibold text-muted">{weapon}</div>
      <div className="truncate text-[13px] font-bold">{skin ?? "Vanilla"}</div>
      {rarity && <div className="rarity-label truncate">{rarity}</div>}
      <div className="mt-1 coin text-[13px] text-money">{fmt(value)}</div>
      {foot && <div className="mt-2">{foot}</div>}
    </div>
  );
}


